import {
  FlavorProfileCard,
  IngredientsMethodsCard,
  KeyCharacteristicsCard,
} from '@/pages/pairing/components/PairingCards';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Empty, Modal, message } from 'antd';
import type { FC } from 'react';
import type { Menu } from '../types';

interface AnalysisModalProps {
  visible: boolean;
  menu: Menu | null;
  goToPairingDetail: (menu: Menu) => void;
  onClose: () => void;
}

const AnalysisModal: FC<AnalysisModalProps> = ({
  visible,
  menu,
  goToPairingDetail,
  onClose,
}) => {
  const analysis = menu?.pairing?.analysis_data?.dish_analysis;

  return (
    <Modal
      title={`Analysis: ${menu?.name}`}
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
        <Button
          key="details"
          type="primary"
          onClick={() => {
            if (!menu) {
              message.warning('No menu found');
              return;
            }
            goToPairingDetail(menu);
            onClose();
          }}
        >
          Pairing Details
        </Button>,
      ]}
      width={1200}
      closeIcon={<CloseOutlined />}
    >
      {analysis ? (
        <div className="grid grid-cols-1 md:grid-cols-3 mt-3 gap-6">
          <KeyCharacteristicsCard analysis={analysis} />
          <IngredientsMethodsCard analysis={analysis} />
          <FlavorProfileCard analysis={analysis} />
        </div>
      ) : (
        <Empty description="No analysis found" />
      )}
    </Modal>
  );
};

export default AnalysisModal;
